import script from "./MaterialIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialIcon.vue?vue&type=script&setup=true&lang=js"

import "./MaterialIcon.vue?vue&type=style&index=0&id=07f63a8a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f63a8a"]])

export default __exports__